import { createApiSlice } from "@common/common-slice/commonSlice";

// routes
import {
  CRUD_PROFICIENCY_LEVEL,
} from "@routes";

const apiConfig = [
  {
    name: "createProficiencyLevel",
    method: "post",
    url: CRUD_PROFICIENCY_LEVEL,
    stateKey: "message",
  },
  {
    name: "getProficiencyLevel",
    method: "get",
    url: CRUD_PROFICIENCY_LEVEL,
    stateKey: "data",
  },
  {
    name: "updateProficiencyLevel",
    method: "put",
    url: CRUD_PROFICIENCY_LEVEL,
    stateKey: "message",
  },
  {
    name: "deleteProficiencyLevel",
    method: "delete",
    url: CRUD_PROFICIENCY_LEVEL,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    generate: false,
    backlogLoading: false,
  },

  reducers: {
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "proficiencyLevel",
  apiConfig,
  customReducers,
);

const proficiencyLevelSlice = slice;

export default proficiencyLevelSlice.reducer;

export const {
  createProficiencyLevel,
  getProficiencyLevel,
  updateProficiencyLevel,
  deleteProficiencyLevel,
} = thunks;

export const {
  rowSelect,
} = actions;
